import { mapState } from 'vuex';

/**
 * 用户角色权限常量(暂定常量处理)
 * @type {{Finance: string, AM: string, BM: string, PM: string}}
 */
const UserRole = {
  ADMIN: 'ADMIN',
  Finance: 'Finance',
  AM: 'AffiliateManager',
  BM: 'BusinessManager',
  PM: 'ProjectManager',
};

export const userInfoMixin = {
  computed: {
    ...mapState({
      userInfo: (state) => state['user'].userInfo,
      roles: (state) => state['user'].userInfo.roles,
    }),
  },
  methods: {
    includeRole(role) {
      if (this.roles.includes(UserRole.ADMIN)) return true;
      if (!role || !this.roles) return false;
      return this.roles.includes(role);
    },
    isFinance() {
      return this.includeRole(UserRole.Finance);
    },
    isAffAm() {
      return this.includeRole(UserRole.AM);
    },
    isAdvPM() {
      return this.includeRole(UserRole.PM);
    },
  },
};
